import { render, staticRenderFns } from "./sos-set.vue?vue&type=template&id=9bc4f83a&scoped=true&"
import script from "./sos-set.vue?vue&type=script&lang=js&"
export * from "./sos-set.vue?vue&type=script&lang=js&"
import style0 from "./sos-set.vue?vue&type=style&index=0&id=9bc4f83a&lang=scss&scoped=true&"
import style1 from "./sos-set.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc4f83a",
  null
  
)

export default component.exports